import { FC } from "react";
import { TokenResponse, useGoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";

import { useTranslation } from "next-i18next";

import Icon from "@components/Icon";
import { useMessage } from "@components/Message";

import { TGoogleLoginProps } from "../types";
import { Button, useMultiStyleConfig } from "@chakra-ui/react";

const GoogleLoginButton: FC<TGoogleLoginProps> = ({ onSubmit }) => {
  const { t } = useTranslation();
  const setMessage = useMessage();

  const styles = useMultiStyleConfig("Login", {});

  const handleFailure = () => {
    setMessage({
      message: t("login-general_error"),
      props: {
        variant: "error",
        icon: <Icon icon="warning" size="1.45rem" />,
        canClose: true,
        padding: "0.45rem 0.75rem",
      },
      zone: "login",
    });
  };

  const handleResponse = (tokenResponse: TokenResponse) => {
    if (!tokenResponse?.access_token) {
      handleFailure();
      return;
    }
    onSubmit({ credential: tokenResponse?.access_token || ''});
  };

  useGoogleOneTapLogin({
    onSuccess: credentialResponse => {
      if (credentialResponse?.credential) {
        onSubmit({ credential: credentialResponse.credential });
      }
    },
    onError: handleFailure,
    cancel_on_tap_outside: false
  });

  const login = useGoogleLogin({
    onSuccess: tokenResponse => handleResponse(tokenResponse),
    onError: () => handleFailure(),
  });

  return (
      <button
        style={styles.googleLogin as React.CSSProperties}
        type="button"
        onClick={() => login()}
        className="google-login-button medium"
      >
        <Icon icon="google" size="24px" />
      </button>
  );
};
export default GoogleLoginButton;
